import React from "react";
import _post from "../Functions/Post"
import Barcode from "react-jsbarcode"

export default class DeliveryForm extends React.Component {

    constructor() {
        super();
        this.state = {}
    }

    render() {
        return (
            <div>
                <div className="row m-3">
                    <div className="col">
                        <p>Source: <b>{this.props.from}</b></p>
                    </div>
                    <div className="col">
                        <p>Destination: <b>{this.props.to}</b></p>
                    </div>
                </div>
                {(this.props.currentPackage > 0) ?
                    this.props.category[this.props.currentPackage].map((item, index) => {
                        return (
                            <div className="row m-3" key={index}>
                                <p>{item.title.substring((item.title.indexOf("]") + 1))}: <b>{item.qty}</b></p>
                            </div>
                        );
                    })
                    : null}
                <Barcode ref={el => (this.componentRef = el)} value={this.props.barcode}/>
            </div>
        )
    }
}